import { render, staticRenderFns } from "./Tolerance.vue?vue&type=template&id=2143062f&scoped=true"
import script from "./Tolerance.vue?vue&type=script&lang=js"
export * from "./Tolerance.vue?vue&type=script&lang=js"
import style0 from "./Tolerance.vue?vue&type=style&index=0&id=2143062f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2143062f",
  null
  
)

export default component.exports